import { Counter } from "./Counter";
import { Reveal } from "./Reveal";
import { GLANCE_STATS } from "../../config/site";

export const Glance = () => (
  <section data-testid="section-glance" className="border-b border-border bg-paper-light">
    <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
      <div className="grid grid-cols-2 gap-x-6 gap-y-10 lg:grid-cols-4">
        {GLANCE_STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div className="border-l-2 border-gold pl-5" data-testid={`glance-stat-${i}`}>
              <p className="font-display text-4xl sm:text-5xl font-medium text-forest">
                <Counter
                  value={s.value}
                  decimals={s.decimals || 0}
                  prefix={s.prefix || ""}
                  suffix={s.suffix || ""}
                />
              </p>
              <p className="mt-2 text-sm text-[#4A4C4A]">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-10 text-sm text-[#4A4C4A]">
          Plot sizes <strong className="text-forest">550–1,845 sq yd</strong> · complete infrastructure by{" "}
          <strong className="text-forest">October 2027</strong>
        </p>
      </Reveal>
    </div>
  </section>
);
